import { createClient } from 'contentful'
import { get } from 'lodash'
import * as Sentry from '@sentry/browser'
import config from '@src/config'

const space = config.contentfulSpaceId
const accessToken = config.contentfulAccessToken
const host = config.contentfulHost

const client = createClient({
  space,
  accessToken,
  host,
})

export const getContentOne = async ({
  contentType,
  fieldName,
  fieldValue,
  include,
}) => {
  try {
    const requestObj = {
      content_type: contentType,
      limit: 1,
    }
    if (fieldName && fieldValue) {
      requestObj[`fields.${fieldName}`] = fieldValue
    }
    if (include) {
      requestObj['include'] = include
    }

    const res = await client.getEntries(requestObj)
    const content = get(res, 'items[0].fields')

    if (!content) {
      Sentry.withScope((scope) => {
        scope.setTag('Contentful')
        Sentry.captureException(
          new Error(`No content returned for ${contentType} content`)
        )
      })
      return Promise.reject()
    }
    return Promise.resolve(content)
  } catch (error) {
    console.log(error)
    Sentry.withScope((scope) => {
      scope.setTag('Contentful')
      Sentry.captureException(
        new Error(`Failed to retreive ${contentType} content`)
      )
    })
  }
}
